import styled from "@emotion/styled";

import { Header } from "~/components/header";
import {
  alignmentCssVariableValues,
  setAlignmentVariables,
  setFullViewportWidthStyles,
} from "~/lib/styles";
import type { ResponsiveVariants } from "~/lib/styles/responsive";

type StyledProps = {
  $responsivePadding?: Partial<ResponsiveVariants<number>>;
};
export const PageContainer = styled.div<StyledProps>`
  ${props => setAlignmentVariables(props.$responsivePadding)}

  display: flex;
  flex-flow: column;
  justify-content: stretch;
  align-items: stretch;

  max-inline-size: 1560px;
  min-block-size: 100vh;
  margin: auto;
  padding-inline: ${alignmentCssVariableValues.pageAlignmentPaddingInline};
  box-sizing: content-box;
`;

export const FooterContainer = styled.footer`
  ${setFullViewportWidthStyles()}
`;

export const StyledHeader = styled(Header)`
  padding-inline: ${alignmentCssVariableValues.headerAlignmentPaddingInline};

  ${props => props.theme.breakpoints.only("tablet")} {
    ${setFullViewportWidthStyles}
  }
`;

export const Content = styled.div`
  flex: 1;

  min-block-size: 50vh;
  padding-inline: ${alignmentCssVariableValues.contentAlignmentPaddingInline};
`;

export const HeaderBottomContainer = styled.div`
  ${setFullViewportWidthStyles()}
`;
